import './DatasetCountBar.css';
import Row from 'react-bootstrap/Row';
import Spinner from 'react-bootstrap/Spinner';


function DatasetCountBar(props) {
    const { datasetCount, metadata } = props;

    if (metadata.length > 0) {
        return (
            <Row className='dataset-count-row'>
                <p className='count-bar-text'>Now displaying {datasetCount} datasets</p>
            </Row>
        );
    } else {
        return (
            <Row className='dataset-count-row'>
                <div style={{ 
                    marginLeft: '0.6em', color: '#fff', 
                    textAlign: 'center', paddingTop: '0.2em',
                    paddingBottom: '0.2em' 
                }}>
                    <p className='count-bar-text' style={{ display: 'inline' }}>Loading ...</p>
                    <Spinner style={{marginLeft: '0.6em'}} animation="grow" size="sm" />
                </div>
            </Row>
        )
    }
}


export default DatasetCountBar;